import { AxiosResponse } from 'axios';

import { APIClients, APIRequestConfig, Logger } from '@futrli/shared-services';

import { PREDICT_API_URL } from '../config';
import { QueryParams } from '../types';

export const OPTIONAL_BASE_URL = PREDICT_API_URL && { baseURL: PREDICT_API_URL };

export const makeRequestWithResponse = async <T>(props: PayloadProps) => {
  try {
    const response = await APIClients.getAPIClient().makeRequest(generatePayload(props));
    return getAxiosResponseData<T>(response as AxiosResponse<T>);
  } catch (error) {
    Logger.error(String(error));
    throw error;
  }
};

export const makeRequest = async (props: PayloadProps) => {
  try {
    await APIClients.getAPIClient().makeRequest(generatePayload(props));
  } catch (error) {
    Logger.error(String(error));
    throw error;
  }
};

/**
 * Gets the data from an AxiosResponse.
 * @param {getAxiosResponseData<T>} response - Gets an axios response and return the data.
 * @returns {T} - Response data.
 */
const getAxiosResponseData = <T>({ data }: AxiosResponse<T>): T => data;

/**
 * Generates a payload object for api requests
 * @param {PayloadProps} props
 * @returns {APIRequestConfig} - Request configuration object
 */
const generatePayload = (props: PayloadProps): APIRequestConfig => {
  const { method } = props;

  return {
    payload: {
      request: {
        ...OPTIONAL_BASE_URL,
        ...props,
        method: method || 'GET'
      }
    }
  };
};

interface PayloadProps {
  data?: unknown;
  method?: 'OPTIONS' | 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  params?: QueryParams;
  url: string;
}
